/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AnalyticProcess } from './analyticProcess';


/**
 * Represents one item of a process group with all belonging analytic processes.
 */
export interface AnalyticProcessGroup { 
    /**
     * Internal AnalyticProcessGroup Key
     */
    id: number;
    name: string;
    type: string;
    isVisibleDashboard: boolean;
    /**
     * ID of the default process of the process group
     */
    defaultProcess: number;
    analyticProcesses: Array<AnalyticProcess>;
}

